import { render, staticRenderFns } from "./ColumnTypes.vue?vue&type=template&id=63966e2a&scoped=true&"
import script from "./ColumnTypes.vue?vue&type=script&lang=js&"
export * from "./ColumnTypes.vue?vue&type=script&lang=js&"
import style0 from "./ColumnTypes.vue?vue&type=style&index=0&id=63966e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63966e2a",
  null
  
)

export default component.exports